export type textProps = {
    productId: string;
    variantId: string;
    title: string;
    desc: string;
    saving: string;
    power: string;
    powerSuffix: string;
    efficiency: string;
    efficiencySuffix: string;
};

export const conf: Record<string, textProps[]> = {
    eu: [
        {
            productId: '9941723873623',
            variantId: '50237885907287',
            title: 'EcoFlow STREAM Standard Kit (800Wp)',
            desc: '2 × 400W Rigid Solar Panels\nSTREAM Microinverter 800W',
            saving: 'Saving Bills: €127',
            power: '798kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
        },
        {
            productId: '9941778137431',
            variantId: '50238848762199',
            title: 'EcoFlow STREAM Balcony Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels\nSTREAM Microinverter 800W\n2 × Lattice Balcony Brackets',
            saving: 'Saving Bills: €137',
            power: '858kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
        },
        {
            productId: '9944391057751',
            variantId: '50244722819415',
            title: 'EcoFlow STREAM Garden Kit (1040Wp)',
            desc: '2 × 520W Rigid Solar Panels\nSTREAM Microinverter 800W\n2 × Garden/Flat Roof Brackets',
            saving: 'Saving Bills: €137',
            power: '858kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
        },
    ],
    uk: [
        {
            productId: '9824771014995',
            variantId: '50632829174099',
            title: 'EcoFlow STREAM Standard Kit (800Wp)',
            desc: '2 × 400W Rigid Solar Panels\nSTREAM Microinverter 800W',
            saving: 'Saving Bills:￡105',
            power: '798kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
        },
        {
            productId: '9824771146067',
            variantId: '50632830091603',
            title: 'EcoFlow STREAM Balcony Kit (900Wp)',
            desc: '2 × 450W Rigid Solar Panels\nSTREAM Microinverter 800W\n2 × Lattice Balcony Brackets',
            saving: 'Saving Bills: ￡115',
            power: '858kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
        },
        {
            productId: '9824771178835',
            variantId: '50632830648659',
            title: 'EcoFlow STREAM Garden Kit (1040Wp)',
            desc: '2 × 520W Rigid Solar Panels\nSTREAM Microinverter 800W\n2 × Garden/Flat Roof Brackets',
            saving: 'Saving Bills: ￡115',
            power: '858kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
        },
    ],
    de: [
        {
            productId: '15094825550205',
            variantId: '55582151115133',
            title: 'EcoFlow STREAM Standard Kit (800 Wp)',
            desc: '2 × 400 W Starres Solarpanel\nSTREAM Mikro-Wechselrichter 800 W',
            saving: 'Kosteneinsparung: 127 €',
            power: '798 kWh',
            powerSuffix: 'Stromerzeugung',
            efficiency: '23%',
            efficiencySuffix: 'Umwandlungsrate der Solarpanels',
        },
        {
            productId: '15094825582973',
            variantId: '55582151934333',
            title: 'EcoFlow STREAM Balkon Kit (900 Wp)',
            desc: '2 × 450 W Starres Solarpanel\nSTREAM Mikro-Wechselrichter 800 W\n2 × Gitterbalkon-Halterungen',
            saving: 'Kosteneinsparung: 137 €',
            power: '858 kWh',
            powerSuffix: 'Stromerzeugung',
            efficiency: '23%',
            efficiencySuffix: 'Umwandlungsrate der Solarpanels',
        },
        {
            productId: '15094825615741',
            variantId: '55582152491389',
            title: 'EcoFlow STREAM Garten Kit (1040 Wp)',
            desc: '2 × 520 W Starres Solarpanel\nSTREAM Mikro-Wechselrichter 800 W\n2 × Garten-/Flachdachhalterungen',
            saving: 'Kosteneinsparung: 137 €',
            power: '858 kWh',
            powerSuffix: 'Stromerzeugung',
            efficiency: '23%',
            efficiencySuffix: 'Umwandlungsrate der Solarpanels',
        },
    ],
    fr: [
        {
            productId: '9804551356763',
            variantId: '50286346142043',
            title: 'Kit standard EcoFlow STREAM (800 Wc)',
            desc: '2 panneaux solaires rigides 400 W\nMicro-onduleur STREAM 800 W',
            saving: 'Économies sur les factures : 84 €',
            power: '1 053 kWh',
            powerSuffix: "d'électricité produite",
            efficiency: '23%',
            efficiencySuffix: 'de conversion des panneaux solaires',
        },
        {
            productId: '9804551422299',
            variantId: '50286347256155',
            title: 'Kit de balcon EcoFlow STREAM (900 Wc)',
            desc: '2 panneaux solaires rigides 450 W\nMicro-onduleur STREAM 800 W\n2 supports de treillis pour balcon',
            saving: 'Économies sur les factures : 91 €',
            power: '1 140 kWh',
            powerSuffix: "d'électricité produite",
            efficiency: '23%',
            efficiencySuffix: 'de conversion des panneaux solaires',
        },
        {
            productId: '9804551455067',
            variantId: '50286347813211',
            title: 'Kit de jardin EcoFlow STREAM (1 040 Wc)',
            desc: '2 panneaux solaires rigides 520 W\nMicro-onduleur STREAM 800 W\n2 supports de jardin/toit plat',
            saving: 'Économies sur les factures : 91 €',
            power: '1 140 kWh',
            powerSuffix: "d'électricité produite",
            efficiency: '23%',
            efficiencySuffix: 'de conversion des panneaux solaires',
        },
    ],
    es: [
        {
            productId: '9804554436955',
            variantId: '50286359642459',
            title: 'Kit estándar EcoFlow STREAM (800 Wp)',
            desc: '2 paneles solares rígidos de 400 W\nInversor STREAM de 800 W',
            saving: 'Ahorro en facturas: 89 €',
            power: '1110 kWh',
            powerSuffix: 'de electricidad generada',
            efficiency: '23%',
            efficiencySuffix: 'de conversión de panel solar',
        },
        {
            productId: '9804554469723',
            variantId: '50286360461659',
            title: 'Kit para balcones EcoFlow STREAM (900 Wp)',
            desc: '2 paneles solares rígidos de 450 W\nInversor STREAM de 800 W\n2 soportes para balcones de celosía',
            saving: 'Ahorro en facturas: 101 €',
            power: '1269 kWh',
            powerSuffix: 'de electricidad generada',
            efficiency: '23%',
            efficiencySuffix: 'de conversión de panel solar',
        },
        {
            productId: '9804554502491',
            variantId: '50286361018715',
            title: 'Kit para jardín EcoFlow STREAM (1040 Wp)',
            desc: '2 paneles solares rígidos de 520 W\nInversor STREAM de 800 W\n2 soportes para techo plano o de jardín',
            saving: 'Ahorro en facturas: 101 €',
            power: '1269 kWh',
            powerSuffix: 'de electricidad generada',
            efficiency: '23%',
            efficiencySuffix: 'de conversión de panel solar',
        },
    ],
    it: [
        {
            productId: '14897221665144',
            variantId: '54987797004664',
            title: 'Kit standard EcoFlow STREAM (600 Wp)',
            desc: '2 pannelli solari rigidi da 400 W\nMicroinverter STREAM da 600 W',
            saving: 'Risparmio sulle bollette: 125 €',
            power: '1.046 kWh',
            powerSuffix: 'di elettricità generata',
            efficiency: '23 %',
            efficiencySuffix: 'Tasso di conversione dei pannelli solari del',
        },
        {
            productId: '14897221697912',
            variantId: '54987797823864',
            title: 'Kit da balcone EcoFlow STREAM (900 Wp)',
            desc: '2 pannelli solari rigidi da 450 W\nMicroinverter STREAM da 600 W\n2 staffe per balcone con ringhiera',
            saving: 'Risparmio sulle bollette: 135 €',
            power: '1.125 kWh',
            powerSuffix: 'di elettricità generata',
            efficiency: '23 %',
            efficiencySuffix: 'Tasso di conversione dei pannelli solari del',
        },
        {
            productId: '14897221730680',
            variantId: '54987798380920',
            title: 'Kit da giardino EcoFlow STREAM (1.040 Wp)',
            desc: '2 pannelli solari rigidi da 520 W\nMicroinverter STREAM da 600 W\n2 staffe per giardino/tetto piatto',
            saving: 'Risparmio sulle bollette: 135 €',
            power: '1.125 kWh',
            powerSuffix: 'di elettricità generata',
            efficiency: '23 %',
            efficiencySuffix: ' Tasso di conversione dei pannelli solari del',
        },
    ],
};

export const diyLinks = {
    eu: 'https://eu.ecoflow.com/pages/stream-balcony-solar-system',
    uk: 'https://uk.ecoflow.com/pages/stream-balcony-solar-system',
    de: 'https://de.ecoflow.com/pages/stream-balcony-solar-system',
    fr: 'https://fr.ecoflow.com/pages/stream-balcony-solar-system',
    it: 'https://it.ecoflow.com/pages/stream-balcony-solar-system',
    es: 'https://es.ecoflow.com/pages/stream-balcony-solar-system',
} as Record<string, string>;
